export default "__VITE_ASSET__xnpPyNlp__"